// src/DoctorFinder/routePaths.js
// Routes dédiées à DoctorFinder

export const DOCTOR_FINDER_ROUTES = {
  LIST: "/doctor-finder",
  DETAILS: "/doctor-finder/:doctorId",
};

export default DOCTOR_FINDER_ROUTES;
